const CreativeAgencyOneBlog = () => {
  return (
    <>
      <div className="section-space bgc-background">
        <div className="section-space--sm-bottom">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="text-center clr-text heading-4">
                  Our Latest News & Blog
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="container-xl">
          <div className="row g-4 gy-md-0">
            <div className="col-md-4">
              <div className="bgc-white rounded-4 padding-6">
                <a href="#" className="link d-block rounded-4 overflow-hidden">
                  <img
                    src="assets/img/creative-agency/blog-post-1.png"
                    alt="blog image"
                    className="img-fluid w-100"
                  />
                </a>
                <div className="padding-top-6">
                  <span className="ca-subheading d-inline-block position-relative font-weight-bold fs-14 clr-text margin-bottom-2">
                    App design
                  </span>
                  <h6 className="heading-6">
                    <a
                      href="#"
                      className="link d-inline-block font-weight-bold clr-text :clr-primary"
                    >
                      Plant Store Landing Page
                    </a>
                  </h6>
                  <p className="mb-0 clr-paragraph">
                    Appropriately empower robust resource maximizing scenarios
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="bgc-white rounded-4 padding-6">
                <a href="#" className="link d-block rounded-4 overflow-hidden">
                  <img
                    src="assets/img/creative-agency/blog-post-2.png"
                    alt="blog image"
                    className="img-fluid w-100"
                  />
                </a>
                <div className="padding-top-6">
                  <span className="ca-subheading d-inline-block position-relative font-weight-bold fs-14 clr-text margin-bottom-2">
                    UI & UX Design
                  </span>
                  <h6 className="heading-6">
                    <a
                      href="#"
                      className="link d-inline-block font-weight-bold clr-text :clr-primary"
                    >
                      Dynamic maintain equity
                    </a>
                  </h6>
                  <p className="mb-0 clr-paragraph">
                    Appropriately empower robust resource maximizing scenarios
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="bgc-white rounded-4 padding-6">
                <a href="#" className="link d-block rounded-4 overflow-hidden">
                  <img
                    src="assets/img/creative-agency/blog-post-3.png"
                    alt="blog image"
                    className="img-fluid w-100"
                  />
                </a>
                <div className="padding-top-6">
                  <span className="ca-subheading d-inline-block position-relative font-weight-bold fs-14 clr-text margin-bottom-2">
                    Digital Marketing
                  </span>
                  <h6 className="heading-6">
                    <a
                      href="#"
                      className="link d-inline-block font-weight-bold clr-text :clr-primary"
                    >
                      Plant Store Landing Page
                    </a>
                  </h6>
                  <p className="mb-0 clr-paragraph">
                    Appropriately empower robust resource maximizing scenarios
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreativeAgencyOneBlog;
